/*
* <license header>
*/

import React, { useState } from 'react'
import { Flex, Text, View } from '@adobe/react-spectrum'
import Info from '@spectrum-icons/workflow/Info'
import Starburst from '@spectrum-icons/workflow/Starburst'
import Close from '@spectrum-icons/workflow/Close'

const SUGGESTED_PROMPTS = {
  'Getting Started': [
    'How do I create a new AppBuilder project?',
    'What is the AppBuilder project structure?',
    'How do I deploy an AppBuilder application?'
  ],
  'Runtime & Actions': [
    'How do I add custom actions to my app?',
    'How do I call Adobe I/O Runtime actions?',
    'What is the difference between web and firefly actions?'
  ],
  'Extensions & App Types': [
    'How do I create a GenStudio extension?',
    'How do I set up an API Mesh?',
    'How do I add Workfront integration?'
  ]
}

export const ChatSection = ({ onSelectPrompt }) => {
  const [bannerDismissed, setBannerDismissed] = useState(false)

  return (
    <Flex direction="column" gap="size-300" flex={1} minHeight={0} UNSAFE_style={{ overflow: 'auto' }}>
      <View>
        <Text UNSAFE_style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem', display: 'block' }}>
          Hi, I&apos;m the AppBuilder Factory Assistant
        </Text>
        <Flex alignItems="start" gap="size-200">
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              backgroundColor: 'var(--card-accent)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '2rem',
              flexShrink: 0
            }}
          >
            🤖
          </div>
          <Text
            UNSAFE_style={{
              color: 'var(--gray-600)',
              fontSize: '0.9375rem',
              lineHeight: 1.5,
              flex: 1
            }}
          >
            Tell me what&apos;s on your mind, or pick a suggestion. I can help with AppBuilder development, deployment, extensions, and integration with Adobe Experience Cloud services.
          </Text>
        </Flex>
      </View>

      {!bannerDismissed && (
        <View
          UNSAFE_style={{
            background: 'linear-gradient(90deg, #a8d8ea 0%, #c77eb5 100%)',
            borderRadius: '8px',
            padding: '1rem 1.25rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
          }}
        >
          <Starburst size="M" UNSAFE_style={{ flexShrink: 0, color: 'var(--gray-900)' }} />
          <span style={{ flex: 1, fontSize: '0.9375rem' }}>
            New! The assistant now supports AppBuilder documentation and Adobe Developer Console integration. Click to learn more.
          </span>
          <button
            type="button"
            onClick={() => setBannerDismissed(true)}
            aria-label="Dismiss"
            style={{
              padding: '0.25rem',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Close size="S" />
          </button>
        </View>
      )}

      <Flex direction="column" gap="size-200">
        {Object.entries(SUGGESTED_PROMPTS).map(([category, prompts]) => (
          <View key={category}>
            <Flex alignItems="center" gap="size-100" marginBottom="size-100">
              <Info size="XS" UNSAFE_style={{ color: 'var(--gray-600)' }} />
              <Text UNSAFE_style={{ fontSize: '0.8125rem', fontWeight: 600, color: 'var(--gray-600)' }}>
                {category}
              </Text>
            </Flex>
            <Flex gap="size-100" wrap>
              {prompts.map((prompt) => (
                <button
                  key={prompt}
                  type="button"
                  onClick={() => onSelectPrompt?.(prompt)}
                  style={{
                    padding: '0.5rem 0.75rem',
                    borderRadius: '999px',
                    border: '1px solid var(--card-border)',
                    backgroundColor: 'var(--white)',
                    color: 'var(--gray-900)',
                    fontSize: '0.875rem',
                    cursor: 'pointer'
                  }}
                >
                  {prompt}
                </button>
              ))}
            </Flex>
          </View>
        ))}
      </Flex>
    </Flex>
  )
}
